import styled, { css } from 'react-emotion';
import refresh from './refresh.png';
import icons from './icons.png';

export const Panel = styled.div`
	height: 53px;
	margin-bottom: 1rem;
	position: relative;
	flex: 1 0 100%;

	&:after {
		clear: both;
		content: '';
		display: block;
		height: 0;
	}
`

export const Button = styled.button`
	background: center top no-repeat url('${refresh}');
	border: 0;
	display: block;
	height: 53px;
	margin: 0 auto;
	outline: none;
	padding: 0;
	width: 166px;
	will-change: transform;

	&:hover, &:active {
		background-position: center bottom;
	}

	&:active {
		transform: translateY(2px);
	}

	@media (max-width: 480px) {
		margin: 0;
	}
`;

export const Social = styled.div`
	bottom: 0;
	position: absolute;
	right: 0;
`;

export const SocialLink = styled.a`
	background: no-repeat url('${icons}');
	display: inline-block;
	height: 44px;
	margin-left: 0.75rem;
	text-decoration: none;
	width: 44px;
`;

export const fb = css`
	background-position: left bottom;

	&:hover {
		background-position: left top;
	}
`;

export const tw = css`
	background-position: right bottom;

	&:hover {
		background-position: right top;
	}
`;
